import {
  type cn as cnLib,
  cnMerge,
  type TV,
  type TWMConfig,
  tv as tvLib,
} from "tailwind-variants";

const customTwMergeConfig = {
  extend: {
    theme: {
      // カスタムフォントサイズ（text-XXSmall, text-XSmall等）をtailwind-mergeに認識させる
      // これにより text-XXSmall と text-sm が同じfont-sizeグループとして認識され、競合解決される
      text: [
        "XXSmall",
        "XSmall",
        "Small",
        "Medium",
        "Large",
        "XLarge",
        "XXLarge",
        "XXXLarge",
      ],
    },
  },
} satisfies TWMConfig["twMergeConfig"];

export const tv: TV = (options, config) => {
  return tvLib(options, {
    twMerge: true,
    twMergeConfig: customTwMergeConfig,
    ...config,
  });
};

/**
 * プロジェクト固有の twMergeConfig を適用した cn ラッパー。
 * カスタムフォントサイズクラス（text-XXSmall 等）の競合解決に対応。
 */
export const cn: typeof cnLib = (...inputs: Parameters<typeof cnMerge>) => {
  return cnMerge(...inputs)({
    twMerge: true,
    twMergeConfig: customTwMergeConfig,
  });
};
